// 이 파일은 원보카 이용약관(한국어) 원문을 그대로 옮긴 것입니다.
// 내용을 수정할 때에는 법무 검토를 거친 원문과 반드시 함께 갱신해 주세요.

import { PolicyBlock } from "./PolicyBlock";

const termsOfUseKo: PolicyBlock[] = [
  {
    "kind": "heading",
    "text": "제 1조 (목적)"
  },
  {
    "kind": "paragraph",
    "text": "이 약관은 MNIS (이하 “회사”)가 제공하는 원보카 서비스 및 관련 제반 서비스 (이하 “서비스”)의 이용과 관련하여 회사와 회원과의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다."
  },
  {
    "kind": "heading",
    "text": "제 2조 (용어의 정의)"
  },
  {
    "kind": "paragraph",
    "text": "이 약관에서 사용하는 용어의 정의는 아래와 같습니다."
  },
  {
    "kind": "list",
    "ordered": true,
    "items": [
      {
        "text": "“회원”이라 함은 회사의 “서비스”에 접속하여 이 약관에 따라 “회사”와 이용계약을 체결하고 “회사”가 제공하는 “서비스”를 이용하는 고객을 말합니다."
      },
      {
        "text": "“아이디(ID)”라 함은 “회원”의 식별과 서비스 이용을 위하여 “회원”이 정하고 “회사”가 승인하는 조건의 문자와 숫자의 조합을 의미합니다."
      },
      {
        "text": "“비밀번호”라 함은 “회원” 자신이 정한 문자 또는 숫자의 조합을 의미합니다."
      },
      {
        "text": "“유료서비스”라 함은 “서비스” 중 “회사”가 유료로 제공하는 각종 서비스 및 제반 서비스를 의미합니다."
      },
      {
        "text": "“게시물” 혹은 “콘텐츠”이라 함은 회원이 서비스를 이용함에 있어 서비스상에 게시한 부호ㆍ문자ㆍ음성ㆍ음향ㆍ화상ㆍ동영상 등의 정보 형태의 글, 사진, 동영상 및 각종 파일과 링크 등을 의미합니다."
      },
      {
        "text": "“이용계약”이란 호스팅 서비스 이용과 관련하여 회사와 회원 간에 체결하는 계약을 의미합니다."
      },
      {
        "text": "가입자”란 회원이 운영하는 홈페이지에 가입한 자를 의미합니다."
      },
      {
        "text": "“침해사고” 란 다음 각 목의 방법으로 정보통신망 또는 이와 관련된 정보시스템을 공격하는 행위로 인하여 발생한 사태를 의미합니다.",
        "children": [
          {
            "text": "해킹, 컴퓨터바이러스 논리폭탄, 메일폭탄, 서비스 거부 또는 고출력 전자기파 등의 방법"
          },
          {
            "text": "정보통신망의 정상적인 보호 ㆍ인증 절차를 우회하여 정보통신망에 접근할 수 있도록 하는 프로그램이나 기술적 장치 등을 정보통신망 또는 이와 관련된 정보시스템에 설치하는 방법"
          }
        ]
      }
    ]
  },
  {
    "kind": "paragraph",
    "text": "위 항에서 정한 것을 제외하고는 관계법령이나 기타 서비스 별 안내에서 정하는 바에 따라 적용됩니다."
  },
  {
    "kind": "heading",
    "text": "제 3조 (약관의 게시와 개정)"
  },
  {
    "kind": "list",
    "ordered": true,
    "items": [
      {
        "text": "“회사”는 이 약관의 내용을 “회원”이 쉽게 알 수 있도록 서비스 초기 화면에 게시합니다."
      },
      {
        "text": "“회사”는 “약관의 규제에 관한 법률”, “정보통신망이용촉진 및 정보보호에관한법률(이하 “정보통신망법”)” , “전자거래기본법”, “전자상거래 등에서의 소비자보호에 관한 법률” 등 관련법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다."
      },
      {
        "text": "회사가 본 약관을 개정하는 경우에는 적용일자 및 개정사유를 명시하여 원보카 홈페이지에 그 적용일자 최소 7일 이전부터 적용일자 전일까지 공지합니다. 다만, 고객의 권리 또는 의무에 관한 중요한 규정의 변경은 최소 30일 전에 고지하고 변경 약관 및 변경 사유를 회원이 등록한 이메일로 통지합니다."
      },
      {
        "text": "고객은 개정된 약관에 대해 거부할 권리가 있으며, 개정된 약관에 동의하지 않을 경우 이용계약 해지를 요청할 수 있으며, 개정된 약관의 효력 발생일 이후에도 서비스를 계속 이용할 경우 약관의 변경사항에 동의하는 것으로 간주합니다."
      },
      {
        "text": "회사는 필요한 경우 특정 서비스에 대하여 개별약관 또는 서비스 별 안내를 정할 수 있으며, 본 약관은 개별약관 및 서비스 별 안내와 함께 적용됩니다."
      },
      {
        "text": "개별약관 및 서비스 별 안내의 변경에 관해서는 본 조 제 3,4항을 준용하여 적용합니다."
      }
    ]
  },
  {
    "kind": "heading",
    "text": "제 4조 (약관의 해석)"
  },
  {
    "kind": "paragraph",
    "text": "이 약관에서 정하지 아니한 사항이나 해석에 대해서는 관계법령, 상관례 및 서비스 별 안내에 따릅니다."
  },
  {
    "kind": "heading",
    "text": "제 5조 (이용계약의 성립)"
  },
  {
    "kind": "list",
    "ordered": true,
    "items": [
      {
        "text": "이용계약은 “회원”이 되고자 하는 자가 약관의 내용에 대하여 동의를 한 다음 회원가입신청을 하고 “회사”가 이러한 신청에 대하여 승낙함으로써 체결됩니다."
      },
      {
        "text": "이용계약의 성립 시기는 “회사”가 가입완료를 신청절차 상에서 표시한 시점으로 합니다."
      },
      {
        "text": "“회원”이 유료서비스를 이용하는 경우 이용대금을 결제한 후 서비스를 이용하는 것을 원칙으로 하며, 유료서비스 이용계약의 성립시기는 “구매완료”를 신청절차 상에서 표시한 시점으로 합니다."
      },
      {
        "text": "“회사”는 서비스 관련설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는 경우에는 승낙을 유보할 수 있습니다."
      },
      {
        "text": "“회사”는 “회원”에 대해 회사정책에 따라 등급별로 구분하여 이용시간, 이용횟수, 서비스 메뉴 등을 세분하여 이용에 차등을 둘 수 있습니다."
      }
    ]
  },
  {
    "kind": "heading",
    "text": "제 6조 (이용신청의 승낙)"
  },
  {
    "kind": "list",
    "ordered": true,
    "items": [
      {
        "text": "“회사”는 “회원”이 이용 신청을 하였을 때 특별한 사정이 없는 한 접수 순서에 따라서 이용 신청을 승낙합니다."
      },
      {
        "text": "“회사”는 다음 각 호에 해당하는 신청에 대하여는 승낙을 하지 않거나 사후에 이용계약을 해지할 수 있습니다.",
        "children": [
          {
            "text": "“회원”이 이 약관에 의하여 이전에 회원자격을 상실한 적이 있는 경우"
          },
          {
            "text": "“회원”의 귀책사유로 인하여 승인이 불가능하거나 기타 규정한 제반 사항을 위반하며 신청하는 경우"
          }
        ]
      }
    ]
  },
  {
    "kind": "heading",
    "text": "제 7조 (회원정보의 변경)"
  },
  {
    "kind": "list",
    "ordered": true,
    "items": [
      {
        "text": "“회원”은 개인정보관리메뉴를 통하여 언제든지 본인의 개인정보를 열람하고 수정할 수 있습니다. 서비스 관리를 위해 필요한 “아이디(ID)”의 수정은 불가합니다.다만, 각 호에 해당하는 경우 “회사”는 직권 또는 “회원”의 신청에 의하여 “아이디(ID)” 변경을 요청할 수 있습니다.",
        "children": [
          {
            "text": "아이디(ID)가 회원의 전화번호, 주민등록번호 등으로 등록되어 있어서 회원 개인정보의 노출 혹은 사생활을 침해할 우려가 있는 경우"
          },
          {
            "text": "타인에게 혐오감을 주거나 미풍양속에 어긋나는 경우"
          },
          {
            "text": "기타 회사 소정의 합리적인 사유가 있는 경우"
          }
        ]
      },
      {
        "text": "“회원”은 회원가입신청 시 기재한 사항이 변경되었을 경우 온라인으로 직접 정보를 수정하거나 전자우편 기타 방법으로 “회사”에 변경사항을 알려야 합니다."
      },
      {
        "text": "본 조 제2항을 이행하지않아 발생한 불이익에 대하여 “회사”는 책임지지 않습니다."
      }
    ]
  },
  {
    "kind": "heading",
    "text": "제 8조 (회사의 의무)"
  },
  {
    "kind": "list",
    "ordered": true,
    "items": [
      {
        "text": "“회사”는 관련법과 본 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 계속적이고 안정적으로 “서비스”를 제공하기 위하여 최선을 다하여 노력합니다."
      },
      {
        "text": "“회사”는 “회원”이 안전하게 “서비스”를 이용할 수 있도록 개인정보 보호를 위해 보안시스템을 갖추어야 하며 개인정보보호정책을 공시하고 준수합니다."
      },
      {
        "text": "“회사”는 서비스이용과 관련하여 “회원”으로부터 제기된 의견이나 불만이 정당하다고 인정할 경우에는 이를 즉시 처리하여야 합니다. 회원이 제기한 의견이나 불만사항에 대해서는 게시판을 활용하거나 전자우편 등을 통하여 “회원”에게 처리과정 및 결과를 전달합니다."
      },
      {
        "text": "“회사”는 이용계약의 체결, 계약사항의 변경 및 해지 등 “회원”과의 계약 관련 절차 및 내용 등에 있어 회원에게 편의를 제공하도록 노력합니다."
      },
      {
        "text": "“회사”는 다음의 사항을 해당 “유료서비스”의 이용초기화면이나 회사홈페이지, FAQ 등에 “회원”이 알기 쉽게 표시합니다.",
        "children": [
          {
            "text": "유료서비스의 명칭 또는 제호"
          },
          {
            "text": "유료서비스의 내용, 이용방법, 이용료, 결제방법 및 기타 이용조건"
          }
        ]
      },
      {
        "text": "“회사”는 시스템 장애 및 오류의 복구, 기술적/관리적으로 긴급을 요하는 경우 “회원”에게 안정적인 서비스 제공을 위해 관리자어드민(admin)에 접근하여 해당 사안을 조치할 수 있습니다."
      },
      {
        "text": "“회사”는 “회원”이 서비스를 이용함에 있어 등록한 게시글 및 그 정보 등이 불법정보에 해당하여 방송통신심의위원회 등 관련 기관으로부터 일정의 행정조치를 전달받은 경우 그에 따른 조치를 이행할 수 있습니다."
      },
      {
        "text": "“회사”는 “회원”과 “회사” 또는 제 3자 간 법적 분쟁이 발생하여 법적 절차의 진행에 따라 서비스 제공의 중단이 필요한 경우 임시적으로 서비스의 이용을 제한할 수 있습니다."
      },
      {
        "text": "“회사”는 서비스 운영에 지장이 되는 장애가 발생되지 않도록 모니터링을 진행하고, 발생하였을 때 이를 즉시 수리 또는 복구합니다. 다만, 천재지변, 전쟁 등 국가 초유의 비상사태 또는 그 밖에 부득이한 경우에는 그 서비스를 일시 중단하거나 중지할 수 있습니다."
      },
      {
        "text": "“회사”는 서버의 영향도를 주는 “불법스팸”이 반복하여 게시글로 등록되는 경우, 혹은 대량게시물로 일괄 등록되어 서버의 영향을 주는 경우. 영향범위 상황에 따라 서버 내 삭제를 진행할 수 있으며 삭제 후에는 원복이 불가합니다. 진행 내용에 따라 메시지 또는 전자우편 등의 회사의 통지방법을 활용하여 고객에게 고지하며, 서비스 이용에 불편이 없도록 합니다."
      },
      {
        "text": "“회사”는 “회원”이 홈페이지를 범죄(불법, 사기, 상표권위반 등) 도구로 사용한다고 판단될 경우 전자상거래센터, 경찰청 사이버 안전국, 방송통신심의위원회 등 관계기관에 신고할 수 있으며 서비스 이용을 제한할 수 있습니다."
      },
      {
        "text": "“회사”는 “유료서비스”를 제공함에 있어 각종 제반서비스를 추가하게 되는 경우 등에 따라 개인정보 처리에 필요한 위수탁 계약을 체결할 수 있으며, 체결 시 개인정보처리방침에 고지할 수 있습니다."
      },
      {
        "text": "“회사”는 서비스 관련 공지사항 및 행정적 사안에 관한 고지절차를 상황에 따라 메시지 또는 전자우편 등의 회사의 통지방법을 활용하여 누락없이 제공하며, 서비스 이용에 불편이 없도록 합니다."
      },
      {
        "text": "회사는 회원의 지적재산권 침해 행위를 방지하기 위하여 키워드 필터링, 자동 감지 시스템 등 합리적이고 통상적인 기술적 보호 조치를 시행하고 있습니다. 다만, 이러한 조치는 침해 행위의 발생을 완전히 방지함을 보장하지는 않습니다."
      },
      {
        "text": "회사는 회원의 콘텐츠가 제3자의 지적재산권을 침해할 우려가 있다고 합리적으로 판단되는 경우, 사전 통지 없이 해당 콘텐츠의 삭제, 접근 제한, 서비스 이용 제한 또는 계정 정지 등의 조치를 취할 수 있습니다."
      }
    ]
  },
  {
    "kind": "heading",
    "text": "제 9조 (회원의 의무)"
  },
  {
    "kind": "list",
    "ordered": true,
    "items": [
      {
        "text": "“회원”은 관계법령, 본 약관의 규정, 개인정보처리방침, 기타 서비스 별 안내 등 “회사”가 통지하는 사항을 준수합니다."
      },
      {
        "text": "“회원”은 서비스를 이용기간 동안 “회사”가 운영하는 이용약관 및 개인정보처리방침, 기타 서비스 별 안내에 동의하는 것으로 간주되며, 정책 변경에 따른 고지에 별도 거부 의사를 표시하지 아니하고 서비스를 계속 사용할 경우 동의한 것으로 갈음됩니다."
      },
      {
        "text": "“회원”은 본 서비스에서 사용하는 “아이디(ID)” 및 “비밀번호”와 관련된 모든 행동을 보호/관리해야 합니다."
      },
      {
        "text": "“회원”은 적법한 절차에 따라 “가입자”의 개인정보를 수집하며 개인정보와 관련한 법령에 따라 보호조치를 수행합니다. 또한 그에 따른 개인정보처리방침을 작성하여 홈페이지 초기 화면에 게시하고 수집한 개인정보를 책임하에 운영하며 위 사항을 만족하지 못했을 때 일어난 어떠한 손실이나 피해에 대해 “회사”는 책임지지 않습니다."
      },
      {
        "text": "“회원”은 정보통신망 이용 촉진 및 정보보호 등에 관한 법률의 광고성 정보 전송 시 관계법령의 의무사항 및 “회사”의 이용약관을 준수하여야 합니다."
      },
      {
        "text": "“회원”은 서비스 이용과 관련하여 다음 각 호에 행위를 하여서는 안됩니다.",
        "children": [
          {
            "text": "다른 회원의 아이디(ID)를 부정사용 또는 도용하는 행위"
          },
          {
            "text": "회사 및 제 3자의 명예를 손상시키거나 업무를 방해하는 행위"
          },
          {
            "text": "회사와 기타 제 3자의 저작권 등 지적재산권에 대한 침해"
          },
          {
            "text": "회사가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시"
          },
          {
            "text": "외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 회사에 공개 또는 게시하는 행위"
          },
          {
            "text": "음란하고 선정적인 사진이나 글 등을 게재하거나 공공질서나 미풍양속에 저해되는 행위"
          },
          {
            "text": "검색엔진 스팸, 도어웨어 페이지, 타 서비스와 매우 유사한 페이지 등 내용이 저급하거나 빈약하고 가입자에게 뚜렷한 부가 가치를 제공하지 않는 행위"
          },
          {
            "text": "회사에서 별도 규정한 콘텐츠 원칙에 어긋나거나, 성격에 부합하지 않는 행위"
          },
          {
            "text": "타인의 의사에 반하여 광고성 정보 등 일정한 내용을 지속적으로 전송하는 행위"
          },
          {
            "text": "불특정 다수를 대상으로 하여 광고, 선전의 게시 등 영리를 목적으로 하는 행위"
          },
          {
            "text": "서비스의 안정적인 운영에 지장을 주거나 줄 우려가 있는 일체의 모든 행위"
          },
          {
            "text": "해킹행위 또는 컴퓨터바이러스의 유포행위"
          },
          {
            "text": "관계법령에 위배되는 행위"
          },
          {
            "text": "기타 회사가 서비스 운영상 부적절하다고 판단하는 행위"
          }
        ]
      },
      {
        "text": "회원은 본 서비스를 이용함에 있어 회사 및 제3자의 저작권, 상표권, 특허권 등 일체의 지적재산권을 침해하여서는 아니 됩니다. 회원이 등록·게시·전송·공유하는 모든 콘텐츠에 대한 책임은 전적으로 회원 본인에게 있습니다."
      },
      {
        "text": "회원이 회사의 지적재산권 보호를 위한 기술적·관리적 조치를 의도적으로 우회하거나 무력화하여 제3자의 지적재산권을 침해한 경우, 이로 인해 발생하는 모든 민·형사상 책임은 회원에게 있으며, 회사는 이에 대하여 어떠한 책임도 부담하지 않습니다."
      },
      {
        "text": "회원의 콘텐츠로 인해 회사가 제3자로부터 민원, 청구, 소송, 손해배상 요구, 행정조치 등을 받은 경우, 해당 분쟁은 회원의 책임과 비용으로 해결되어야 하며, 이로 인해 회사에 발생한 손해(변호사 비용 포함)에 대하여 회원은 회사를 면책하고 배상할 책임을 부담합니다."
      }
    ]
  },
  {
    "kind": "heading",
    "text": "제 10조 (”회원”에 대한 통지의무)"
  },
  {
    "kind": "list",
    "ordered": true,
    "items": [
      {
        "text": "“회사”는 “회원”에 대한 통지가 필요한 경우 본 약관에 별도 규정이 없는 한 “회원”이 지정한 전자우편주소 또는 서비스 내 알림, 메시지 등으로 통지할 수 있습니다."
      },
      {
        "text": "“회사”는 “회원” 전체에 대한 통지의 경우 7일 이상 원보카 어플리케이션 내 공지사항에 표기함으로써 제 1항의 통지에 갈음할 수 있습니다."
      }
    ]
  },
  {
    "kind": "heading",
    "text": "제 11조 (보안 시스템 관리 및 의무)"
  },
  {
    "kind": "list",
    "ordered": true,
    "items": [
      {
        "text": "“회사”는 보안상 심각하고 시급을 요하는 프로그램 결함이나 장애 혹은 그에 준하는 사건발생 시, 회사에서 서비스에 포함되는 부분에 한하여 일괄적으로 패치 할 수 있습니다."
      },
      {
        "text": "“회사”는 보안상 심각하고 시급을 요하는 경우 회사에서 “회원”의 인증관련 정보를 응급 변경할 수 있습니다."
      },
      {
        "text": "“회원”은 “회사”의 서비스를 이용하여 회사 또는 다른 회원의 보안을 위협하는 다음 각 호를 하지 않습니다.",
        "children": [
          {
            "text": "컴퓨터 바이러스 외 악성 프로그램 등 불법 유포행위"
          },
          {
            "text": "회원 정보시스템 및 이외의 시스템을 대상으로 한 취약점 스캐닝, 불법 침입 행위"
          },
          {
            "text": "대량의 트래픽(traffic)을 유발시켜 정상적인 서비스를 방해하는 행위"
          },
          {
            "text": "불법 광고성 스팸게시물 혹은 대량게시물을 반복적으로 업로드하여, “회사”의 “서비스” 이용에 불편을 초래하고, 불법 자동화(매크로)등록을 통해 시스템 내 속도지연, 안전성의 문제를 유발하는 행위"
          },
          {
            "text": "기타 시스템 운영 및 회사의 업무를 방해하는 각종 침해 행위"
          }
        ]
      },
      {
        "text": "“회사”는 본 조에 의한 보안 관련 조치 내용을 본 약관 제 10조에 근거하여 조치 후 통지하거나 통지를 제외할 수 있습니다."
      },
      {
        "text": "“회사”는 본 조와 관련한 조치에 있어 “회원”에게 손해가 발생하지 않도록 최선을 다하여 조치를 진행합니다. 긴급 조치가 필요한 간헐적 상황에 따라 다수의 “회원”에게만 적용되는 이슈가 감지되었을 때, 일부 “회원”의 손해에 대한 배상 책임을 부담하지 않고 조치를 이행할 수 있습니다."
      }
    ]
  },
  {
    "kind": "heading",
    "text": "제 12조 (보안 시스템 관리 및 의무)"
  },
  {
    "kind": "list",
    "ordered": true,
    "items": [
      {
        "text": "서비스 제공은 “회사”의 업무상 또는 기술상 이유가 없는 한 연중무휴, 1일 24시간 서비스 제공을 원칙으로 합니다."
      },
      {
        "text": "“회사”는 서비스의 제공에 필요한 경우 정기점검을 실시할 수 있으며, 정기점검시간은 서비스 제공화면에 공시한 바에 따릅니다."
      }
    ]
  },
  {
    "kind": "heading",
    "text": "제 13조 (서비스의 중지)"
  },
  {
    "kind": "list",
    "ordered": true,
    "items": [
      {
        "text": "“회사”는 긴급한 시스템 점검, 증설 및 교체 등 부득이한 사유로 인하여 예고 없이 일시적으로 서비스를 중단할 수 있으며, 새로운 서비스로의 교체 등 “회사”가 적절하다고 판단하는 사유에 의하여 현재 제공되는 서비스를 완전히 중단할 수 있습니다. 이 경우 “회사”는 본 약관 제10조(“회원”에 대한 통지의무)에서 정한 방법으로 “회원에게 통지합니다. 다만, “회사”가 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다."
      },
      {
        "text": "“회사”는 다음 각 호의 경우에 서비스 제공을 일시 중단할 수 있습니다. 서비스 중단이 발생할 경우 “회사”는 “회원”에게 이러한 사실을 본 약관 제10조(“회원”에 대한 통지의무)에서 정한 방법으로 사전 또는 사후에 통보하여야 하며, “회사”가 운영하는 홈페이지를 통하여 게시하는 것으로 대신할 수 있습니다.",
        "children": [
          {
            "text": "서버 설비의 보수 혹은 서비스 제공상 점검이 불가피한 경우"
          },
          {
            "text": "전기통신사업법에 규정된 기간통신사업자가 전기통신서비스를 중지하는 경우"
          },
          {
            "text": "전용회선 경로상의 장애가 발생한 경우"
          },
          {
            "text": "천재지변, 국가비상사태 등의 사유로 인하여 기계적인 작동 불능이 발생한 경우"
          },
          {
            "text": "악의적 외부공격으로 인한 접속량 대량 증가가 발생한 경우 (ex. DDos공격 등)"
          }
        ]
      },
      {
        "text": "“회사”는 “회사”가 통제할 수 없는 사유로 인한 서비스 중단의 경우(시스템 관리자의 고의, 과실 없는 디스크 장애, 시스템 다운 등)에 사전통지가 불가능하며 타인(기간 통신 사업자, 제휴 서비스 제공 사업자 등)의 고의, 과실로 인한 시스템 중지 등의 경우에는 통지하지 않습니다."
      }
    ]
  },
  {
    "kind": "heading",
    "text": "제 14조 (정보의 제공)"
  },
  {
    "kind": "list",
    "ordered": true,
    "items": [
      {
        "text": "“회사”는 “회원”이 서비스 이용 중 필요하다고 인정되는 다양한 정보를 공지사항이나 전자우편 등의 방법으로 “회원”에게 제공할 수 있습니다. 다만, “회원”은 관련법에 따른 거래관련 정보, 고객센터 답변 등을 제외하고 언제든지 전자우편 등을 통하여 수신거절을 할 수 있습니다."
      }
    ]
  },
  {
    "kind": "heading",
    "text": "제 15조 (이용제한 등)"
  },
  {
    "kind": "list",
    "ordered": true,
    "items": [
      {
        "text": "“회사”는 “회원”이 본 약관의 의무를 위반하거나 서비스의 정상적인 운영을 방해한 경우, 서비스 이용을 제한할 수 있습니다. 이 경우 “회사”는 본 약관 제10조(“회원”에 대한 통지의무)에서 정한 방법으로 “회원에게 통지합니다. 다만, “회사”가 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다."
      },
      {
        "text": "“회사”는 본 약관 제9조(“회원”의 의무) 규정에 위배되는 행위를 한 경우 사전통지 없이 서비스 이용계약을 해지하거나 회원자격을 적절한 방법으로 제한 및 정지할 수 있습니다. 본 항에 따른 계약해지 시 서비스 이용을 통해 획득한 혜택 등도 모두 소멸되며, “회사”는 이에 대해 별도로 보상하지 않습니다."
      },
      {
        "text": "본 조에 따라 서비스 이용을 제한하거나 계약을 해지하는 경우 “회사”는 본 약관 제10조(“회원”에 대한 통지의무)에서 정한 방법으로 “회원에게 통지합니다. 다만, “회사”가 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다."
      },
      {
        "text": "“회원”은 본 조에 따른 이용제한 등에 대해 “회사”가 정한 절차에 따라 이의신청을 할 수 있습니다. 이 때 이의가 정당하다고 회사가 인정하는 경우 회사는 즉시 서비스의 이용을 재개합니다."
      }
    ]
  },
  {
    "kind": "heading",
    "text": "제 16조 (서비스의 변경)"
  },
  {
    "kind": "list",
    "ordered": true,
    "items": [
      {
        "text": "“회사”는 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 제공하고 있는 전부 또는 일부 서비스를 변경할 수 있습니다. 서비스의 내용, 이용방법, 이용시간에 대하여 변경이 있는 경우에는 변경사유, 변경될 서비스의 내용 및 제공일자 등은 그 변경 전 7일 이상 해당 서비스 초기화면에 게시하여야 합니다."
      },
      {
        "text": "“회사”는 무료로 제공되는 서비스의 일부 또는 전부를 회사의 정책 및 운영의 필요상 수정, 중단, 변경할 수 있으며, 이에 대하여 관련법에 특별한 규정이 없는 한 “회원”에게 별도의 보상을 하지 않습니다."
      },
      {
        "text": "“유료서비스”의 변경 내용이 중대하거나 “회원”에게 불리한 경우에는 “회사”가 해당 “유료서비스”를 제공받는 “회원”에게 제10조(“회원”에 대한 통지의무)에서 정한 방법으로 “회원”에게 통지합니다. 다만, “회원”이 “유료서비스” 변경에 대한 내용을 거부하여 서비스 제공이 불가능할 경우 해당 서비스의 제공을 중지하거나 계약을 중단할 수 있으며 이 경우 환불은 본 약관 제 19조(환불)에 규정된 내용에 따라 진행됩니다."
      }
    ]
  },
  {
    "kind": "heading",
    "text": "제 17조 (”회원”의 이용계약 해지 등)"
  },
  {
    "kind": "list",
    "ordered": true,
    "items": [
      {
        "text": "“회원”은 언제든지 개인정보관리메뉴를 통하여 서비스 탈퇴 신청을 할 수 있으며, “회사”는 관련법 등이 정하는 바에 따라 이를 즉시 처리하여야 합니다."
      },
      {
        "text": "“회원”이 계약을 해지할 경우, 관련법 및 개인정보보호정책에 따라 “회사”가 회원정보를 보유하는 경우를 제외하고는 해지 즉시 “회원”의 모든 데이터는 소멸됩니다."
      },
      {
        "text": "“회원”이 계약을 해지하는 경우, 본인 계정에 등록된 모든 데이터 일체는 삭제됩니다."
      },
      {
        "text": "“회사”는 “회원”이 다음 각 호에 해당할 경우에 사전통지 없이 이용계약을 해지할 수 있으며 다음 각 호에 의해 해지된 “회원”이 다시 이용 신청을 하는 경우 이용 승낙을 거부하거나 사후에 이용계약을 해지할 수 있습니다.",
        "children": [
          {
            "text": "서비스 운영을 고의로 방해하여 회사의 브랜드 가치에 막대한 손해를 입힌 경우"
          },
          {
            "text": "본 약관 제15조에 의하여 이용제한된 후 이용기간 내에 제한 사유를 해소하지 않는 경우"
          },
          {
            "text": "“회사”에 악의적인 의도를 가지고 어떠한 형태든 손실을 미친 경우"
          }
        ]
      }
    ]
  },
  {
    "kind": "heading",
    "text": "제 18조 (이용요금)"
  },
  {
    "kind": "list",
    "ordered": true,
    "items": [
      {
        "text": "서비스 이용요금의 세부 내역 및 그 변경사항은 본 약관 제8조(“회사”의 의무) 5항에 따라 회사의 홈페이지에 명기합니다."
      },
      {
        "text": "“회원”이 납부하여야 하는 서비스의 이용요금 종류는 다음 각 호와 같습니다.",
        "children": [
          {
            "text": "슬롯 추가 : “일회성 결제 유료서비스” 이용에 해당하는 상품"
          },
          {
            "text": "확장팩 부스트 : “구독 결제 유료서비스” 이용에 해당하는 상품"
          }
        ]
      },
      {
        "text": "“회사”에서 판매하는 상품의 가격이 변경되더라도 상품 가격이 변경 되기 이전의 구매한 결제에 대해서는 특별한 사정이 없는 한 소급 적용되지 않습니다."
      }
    ]
  },
  {
    "kind": "heading",
    "text": "제 19조 (환불)"
  },
  {
    "kind": "list",
    "ordered": true,
    "items": [
      {
        "text": "“유료서비스” 이용 중 이용요금 환불은 “회사” 고객센터로 환불 요청 접수 시 환불 가능합니다."
      },
      {
        "text": "“회사”는 결제와 동일한 방법으로 환불을 진행하며, 결제와 동일한 방법의 환불이 불가능한 때에는 이를 환불이 불가능함을 인지한 때 로부터 3영업일 이내에 고지합니다. 다만, 수납확인이 필요한 결제수단의 경우에는 수납확인일로부터 5영업일 이내에 이를 환불하도록 합니다."
      },
      {
        "text": "“일회성 결제 유료서비스” 결제 요금 환불은 결제일로부터 7일 이내 환불 요청시 결제 요금 만큼을 환불 신청일로부터 5영업일 이내에 환불합니다. 결제일로부터 7일이 지난 경우 현재 “회사”의 “유로서비스”인 슬롯 추가와 같은 일회성 결제 상품의 경우, 일회성 결제 상품은 결제한 시점으로부터 이미 가치가 사용되었다고 판단하므로 환불이 불가능합니다."
      },
      {
        "text": "“구독 결제 유료서비스” 결제 요금 환불은 구글플레이스토어, 앱스토어 등 각 플랫폼 환불 정책에 따르며, 일반적으로 ‘구독 취소’의 경우 이미 가치가 사용되었다고 판단하므로 다음 갱신일 까지 구독이 지속되며 별도의 환불은 각 플랫폼의 정책이 허락하지 않는 경우 환불이 불가능합니다."
      }
    ]
  },
  {
    "kind": "heading",
    "text": "제 20조 (손해배상)"
  },
  {
    "kind": "list",
    "ordered": true,
    "items": [
      {
        "text": "“회사”는 제휴 서비스 등 “회사”가 직접 운영하지 아니하는 서비스에 대해서는 그로 인한 “회원”의 손해에 대하여 배상 책임을 부담하지 않습니다."
      },
      {
        "text": "단, 본 약관 제 13조에 따른 서비스 제공을 위한 필수 상황에 의한 서비스의 중지는 별도 배상하지 않습니다."
      }
    ]
  },
  {
    "kind": "heading",
    "text": "제 21조 (저작권의 귀속 및 관리, 이용제한)"
  },
  {
    "kind": "list",
    "ordered": true,
    "items": [
      {
        "text": "“회원”이 “서비스” 내에 게시한 “게시물”의 저작권은 해당 “게시물”의 저작자에게 귀속됩니다."
      },
      {
        "text": "“회원”이 “서비스” 내에 게시하는 “콘텐츠”는 검색결과 내지 “서비스” 및 관련 프로모션 등에 노출될 수 있으며, 해당 노출을 위해 필요한 범위 내에서는 일부 수정, 복제, 편집되어 게시될 수 있습니다. 이 경우, “회사”는 저작권법 규정을 준수하며, “회원”은 언제든지 고객센터 또는 “서비스” 내 관리기능을 통해 해당 “게시물”에 대해 삭제, 검색결과 제외, 비공개 등의 조치를 취할 수 있습니다."
      },
      {
        "text": "“회사”는 제2항 이외의 방법으로 “회원”의 “게시물”을 이용하고자 하는 경우에는 전화, 팩스, 전자우편 등을 통해 사전에 “회원”의 동의를 얻어야 합니다."
      },
      {
        "text": "“회원”의 게시물이 정보통신망법 및 저작권법 등 관계법령에 위반되는 내용을 포함하는 경우, 권리자는 관계법이 정한 절차에 따라 해당 “게시물”의 게시중단 및 삭제 등을 요청할 수 있으며, “회사”와 “회원”은 관계법에 따라 조치를 취하여야 합니다."
      },
      {
        "text": "“회사”는 전항에 따른 권리자의 요청이 없는 경우라도 권리침해가 인정될 만한 사유가 있거나 기타 “회사” 정책 및 관계법령에 위반되는 경우에는 관계법에 따라 해당 게시물에 대해 임시조치 등을 취할 수 있습니다."
      },
      {
        "text": "“서비스”에 대한 저작권 및 지적재산권은 “회사”에 귀속됩니다. 단, “회원”의 게시물 및 제휴계약에 따라 제공된 저작물 등은 제외합니다."
      }
    ]
  },
  {
    "kind": "heading",
    "text": "제 22조 (면책)"
  },
  {
    "kind": "list",
    "ordered": true,
    "items": [
      {
        "text": "“회사”는 “회원”이 “회사”의 “서비스” 제공으로부터 기대되는 이익을 얻지 못하였거나, 서비스로부터 수반되는 잠재가치 및 서비스에 대한 취사선택 또는 이용으로 발생하는 손해 등에 대해서는 책임이 없습니다."
      },
      {
        "text": "“회사”는 천재지변 또는 이에 준하는 불가항력으로 인하여 “서비스”를 제공할 수 없는 경우에는 “서비스” 제공에 관한 책임이 면제 됩니다."
      },
      {
        "text": "“회사”는 “회원”의 귀책사유로 인한 “서비스” 이용의 장애에 대하여는 책임을 지지 않습니다."
      },
      {
        "text": "“회사”는 “회원”이 “서비스”와 관련하여 게재한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관하여는 책임을 지지 않습니다."
      },
      {
        "text": "“회사”는 “회원” 간 또는 “회원”과 제3자 상호간에 “서비스”를 매개로 하여 거래 등을 한 경우에는 책임이 면제됩니다."
      },
      {
        "text": "“회사”는 무료로 제공되는 “서비스” 이용과 관련하여 관계법령에 특별한 규정이 없는 한 책임을 지지 않습니다."
      },
      {
        "text": "“회원”은 본 “서비스”를 이용하여 타인에게 피해를 주거나 미풍양속을 해치는 행위 등을 통해 발생하는 모든 법적인 책임은 “회원”에게 있습니다."
      }
    ]
  },
  {
    "kind": "heading",
    "text": "제 23조 (준거법 및 재판관할)"
  },
  {
    "kind": "list",
    "ordered": true,
    "items": [
      {
        "text": "“회사”와 “회원”간 제기된 소송은 대한민국법을 준거법으로 합니다."
      },
      {
        "text": "“회사”와 “회원”간 발생한 분쟁에 관한 소송은 민사소송법 상의 관할법원에 제소합니다."
      }
    ]
  }
];

export default termsOfUseKo;
